import { TypedDocumentNode, gql } from '@apollo/client';

import useMutation from '@sorare/core/src/hooks/graphql/useMutation';

import {
  DeleteCompetitionSubscriptionMutation,
  DeleteCompetitionSubscriptionMutationVariables,
} from './__generated__/useDeleteCompetitionSubscription.graphql';

const DELETE_COMPETITION_SUBSCRIPTION_MUTATION = gql`
  mutation DeleteCompetitionSubscriptionMutation($slug: String!) {
    deleteSubscription(input: { slug: $slug }) {
      subscription {
        slug
        anySubscribable {
          slug
          currentUserSubscription {
            slug
          }
        }
      }
      errors {
        message
        code
      }
    }
  }
` as TypedDocumentNode<
  DeleteCompetitionSubscriptionMutation,
  DeleteCompetitionSubscriptionMutationVariables
>;

export const useDeleteCompetitionSubscription = () => {
  const [unsubscribe] = useMutation(DELETE_COMPETITION_SUBSCRIPTION_MUTATION);

  return [
    async ({
      competitionSlug,
      subscriptionSlug,
    }: {
      competitionSlug: string;
      subscriptionSlug: string;
    }) =>
      unsubscribe({
        variables: { slug: subscriptionSlug },
        optimisticResponse: {
          deleteSubscription: {
            __typename: 'deleteSubscriptionPayload',
            subscription: {
              slug: subscriptionSlug,
              anySubscribable: {
                slug: competitionSlug,
                currentUserSubscription: null,
                __typename: 'Competition',
              },
              __typename: 'EmailSubscription',
            },
            errors: [],
          },
        },
      }),
  ];
};
